/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-09.
 * Users service
 *
 * If you need to remap data, this is the place to doit,
 * keep clean the actions.
 */
import request from './request';
import { serializeParams } from '../common/helpers';

export const get = (url = '', params = {}) => {
    return request().get(`${url}${serializeParams(params)}`)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            return error;
        });
};

export const post = (url = '', params = {}) => {
    return request().post(url, params)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            return error;
        });
};

export const put = (url = '', params = {}) => {
    return request().put(url, params)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            return error;
        });
};

export const getUsers = (params = {}) => {
    return request()
        .get(`users?id=${params.id}&projection=usersProjection`)
        .then(response => response.data._embedded.users)
        .catch(() => []);
};



// WEBPACK FOOTER //
// ./services/users.js